import React, { Dispatch, SetStateAction } from 'react';
import RadiusInput from 'components/common/formElements/radiusInput';
import ContainerWithShadow from 'components/common/ContainerWithShadow';
import Title from 'components/common/Title';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from 'components/common/formElements/checkbox';
import style from 'components/common/calendar/index.module.scss';
import ArrowIcon from 'components/common/calendar/arrowIcon';
import styles from './styles.module.scss';
import { ChangeActionPayload } from '../reducer';

interface Props {
  permissionToEditTimetable: boolean;
  permissionToEditResources: boolean;
  onChange(value: ChangeActionPayload): void;
  setGrade: Dispatch<SetStateAction<string[]>>;
  grade: string[];
  name: string;
  handleSetName: (e: React.FormEvent<HTMLInputElement>) => void;
  requestError: string;
  errors: {
    grades?: boolean;
    name?: boolean;
  };
}

const ProfileForm: React.FC<Props> = ({
  permissionToEditTimetable,
  permissionToEditResources,
  requestError,
  onChange,
  handleSetName,
  name,
  grade,
  setGrade,
  errors,
}) => {
  const useStyles = makeStyles(() =>
    createStyles({
      formControl: {
        margin: '0px ',
        minWidth: 120,
        width: '100%',
        height: 56,
        border: '0.1px solid rgba(0, 0, 0, 0.23) !important',
        boxSizing: 'border-box',
        borderRadius: 100,
      },
      select: {
        maxHeight: '200px',
      },
    })
  );

  const classes = useStyles();

  const handleChangeGrade = (event: React.ChangeEvent<{ value: unknown }>) => {
    setGrade([event.target.value] as string[]);
  };

  return (
    <ContainerWithShadow className={`${styles.root} profile`}>
      <Title className={styles.title}>Tell Us About Your Scholar</Title>
      <div>
        <RadiusInput
          className={styles.input}
          variant="outlined"
          label="Prefered name"
          type="text"
          name="name"
          onChange={handleSetName}
          value={name}
          error={errors.name || false}
          inputProps={{ maxLength: 10 }}
        />
        <div
          className={`${style.customSelect} ${style.margin} ${
            errors.grades ? styles.errorSelect : ''
          }`}
        >
          <FormControl className={`${classes.formControl} ${styles.formInput}`}>
            <Select
              value={[...grade]}
              onChange={handleChangeGrade}
              inputProps={{ 'aria-label': 'Without label' }}
              IconComponent={() => <ArrowIcon />}
              displayEmpty
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                classes: { paper: styles.formSelect },
                getContentAnchorEl: null,
              }}
            >
              <MenuItem value="" disabled>
                Select Grade
              </MenuItem>
              <MenuItem value="Pre K">Pre K</MenuItem>
              <MenuItem value="K">K</MenuItem>
              <MenuItem value="1">Grade 1</MenuItem>
              <MenuItem value="2">Grade 2</MenuItem>
              <MenuItem value="3">Grade 3</MenuItem>
              <MenuItem value="4">Grade 4</MenuItem>
              <MenuItem value="5">Grade 5</MenuItem>
              <MenuItem value="6">Grade 6</MenuItem>
              <MenuItem value="7">Grade 7</MenuItem>
              <MenuItem value="8">Grade 8</MenuItem>
              <MenuItem value="9">Grade 9</MenuItem>
              <MenuItem value="10">Grade 10</MenuItem>
              <MenuItem value="11">Grade 11</MenuItem>
              <MenuItem value="12">Grade 12</MenuItem>
            </Select>
          </FormControl>
          {requestError && (
            <span className="error-message">{requestError}</span>
          )}
        </div>
        <fieldset className={styles.permissions}>
          <Title variant="h4" className={styles.permissionsTitle}>
            Permissions
          </Title>
          <Checkbox
            className={styles.checkbox}
            label="Allow scholar to edit timetable"
            checked={permissionToEditTimetable}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onChange({ permissionToEditTimetable: e.target.checked })
            }
          />
          <Checkbox
            className={styles.checkbox}
            label="Allow scholar to edit digital resources"
            checked={permissionToEditResources}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onChange({ permissionToEditResources: e.target.checked })
            }
          />
        </fieldset>
      </div>
    </ContainerWithShadow>
  );
};
export default ProfileForm;
